import { toString30pk9tzaqopn as toString } from './Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PairClass;
function Pair() {
  if (PairClass === VOID) {
    class $ {
      constructor(first, second) {
        this.first_1 = first;
        this.second_1 = second;
      }
      toString() {
        return '(' + toString(this.first_1) + ', ' + toString(this.second_1) + ')';
      }
      component1_7eebsc_k$() {
        return this.first_1;
      }
      component2_7eebsb_k$() {
        return this.second_1;
      }
      hashCode() {
        var result = this.first_1 == null ? 0 : hashCode(this.first_1);
        result = imul(result, 31) + (this.second_1 == null ? 0 : hashCode(this.second_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Pair()))
          return false;
        if (!equals(this.first_1, other.first_1))
          return false;
        if (!equals(this.second_1, other.second_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Pair');
    PairClass = $;
  }
  return PairClass;
}
function to(_this__u8e3s4, that) {
  return new (Pair())(_this__u8e3s4, that);
}
var TripleClass;
function Triple() {
  if (TripleClass === VOID) {
    class $ {
      constructor(first, second, third) {
        this.first_1 = first;
        this.second_1 = second;
        this.third_1 = third;
      }
      toString() {
        return '(' + toString(this.first_1) + ', ' + toString(this.second_1) + ', ' + toString(this.third_1) + ')';
      }
      hashCode() {
        var result = this.first_1 == null ? 0 : hashCode(this.first_1);
        result = imul(result, 31) + (this.second_1 == null ? 0 : hashCode(this.second_1)) | 0;
        result = imul(result, 31) + (this.third_1 == null ? 0 : hashCode(this.third_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Triple()))
          return false;
        if (!equals(this.first_1, other.first_1))
          return false;
        if (!equals(this.second_1, other.second_1))
          return false;
        if (!equals(this.third_1, other.third_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Triple');
    TripleClass = $;
  }
  return TripleClass;
}
//region block: exports
export {
  Pair as Paire9pteg33gng7,
  Triple as Triple1vhi3d0dgpnjb,
  to as to2cs3ny02qtbcb,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
